import axios from 'axios';
const baseUrl = process.env.REACT_APP_AWS_API_GATEWAY_URL;

export const fetcSchemeFlows = (accessToken) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
            'X-Api-Key': 'zBnH4QVGG9dGmTcErSYPdD5eKPgSIaRQ'
        },
        data: {
            process: "component_schema_select",
            action: "SELECT",
            variables: "{}"
        }
    })
}

export const getCompanies = (accessToken) => {
    return axios({
        method: 'POST',
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`
        },
        data: JSON.stringify({
            'process': 'flow_select',
            'action': 'SELECTCOMPANIES_FLOWS',
            'variables': '{}'
        })
    })
}
